import Card from "components/card";
import { MdEmail, MdSend, MdSmartToy, MdQuestionAnswer } from "react-icons/md";
import { FaBell } from "react-icons/fa";

const NotificationStats = () => {
  // Dummy data for notification statistics
  const totalPushNotifications = 234567;
  const totalEmailsDelivered = 189234;
  const latteAIReminders = 45782;
  const latteAIResponses = 31456;

  // Format large numbers
  const formatNumber = (num: number) => {
    if (num >= 1000000) {
      return `${(num / 1000000).toFixed(1)}M`;
    }
    if (num >= 1000) {
      return `${(num / 1000).toFixed(1)}k`;
    }
    return num.toString();
  };

  return (
    <Card extra="p-6 h-full">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-bold text-navy-700 dark:text-white">
          Latte Connection Engine
        </h3>
        <MdSend className="text-xl text-brand-500" />
      </div>

      {/* 2x2 Grid layout for metrics */}
      <div className="grid grid-cols-2 gap-6 mb-6">
        <div className="flex items-center gap-2">
          <FaBell className="text-2xl text-yellow-500" />
          <div>
            <p className="text-sm text-gray-600 dark:text-gray-400">Push Notifications</p>
            <p className="text-2xl font-bold text-navy-700 dark:text-white">
              {formatNumber(totalPushNotifications)}
            </p>
          </div>
        </div>

        <div className="flex items-center gap-2">
          <MdEmail className="text-2xl text-blue-500" />
          <div>
            <p className="text-sm text-gray-600 dark:text-gray-400">Emails Delivered</p>
            <p className="text-2xl font-bold text-navy-700 dark:text-white">
              {formatNumber(totalEmailsDelivered)}
            </p>
          </div>
        </div>

        <div className="flex items-center gap-2">
          <MdSmartToy className="text-2xl text-purple-500" />
          <div>
            <p className="text-sm text-gray-600 dark:text-gray-400">Assistant Engagement Reminders</p>
            <p className="text-2xl font-bold text-navy-700 dark:text-white">
              {formatNumber(latteAIReminders)}
            </p>
          </div>
        </div>

        <div className="flex items-center gap-2">
          <MdQuestionAnswer className="text-2xl text-green-500" />
          <div>
            <p className="text-sm text-gray-600 dark:text-gray-400">AI Questions Answered</p>
            <p className="text-2xl font-bold text-navy-700 dark:text-white">
              {formatNumber(latteAIResponses)}
            </p>
          </div>
        </div>
      </div>


      {/* Bottom summary */}
      <div className="border-t border-gray-200 dark:border-navy-600 pt-4">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-gray-600">Total Delivered</p>
            <p className="text-2xl font-bold text-navy-700 dark:text-white">
              {formatNumber(totalPushNotifications + totalEmailsDelivered + latteAIReminders + latteAIResponses)}
            </p>
          </div>
          <div className="text-right">
            <p className="text-sm text-gray-600">Success Rate</p>
            <p className="text-2xl font-bold text-green-500">99.2%</p>
          </div>
        </div>
      </div>
    </Card>
  );
};

export default NotificationStats;